import { createTheme } from '@mui/material/styles';

const brand = {
  primary: '#36c9a2',
  primaryDark: '#2aad8a',
  gradient: 'linear-gradient(135deg, #36c9a2 0%, #4facfe 100%)',
  gradientHover: 'linear-gradient(135deg, #2aad8a 0%, #3a85d4 100%)',
  bgDark: '#0d1b2a',
  bgDarkGreen: '#0d3d2e',
  paperDark: '#0f1923',
};

const typography = {
  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
};

const shape = { borderRadius: 8 };

const appBarOverride = {
  styleOverrides: {
    root: {
      background: `linear-gradient(135deg, ${brand.bgDark} 0%, ${brand.bgDarkGreen} 100%)`,
      boxShadow: '0 2px 12px rgba(0,0,0,0.4)',
    },
  },
};

const sharedComponents = {
  MuiAppBar: appBarOverride,
  MuiButton: {
    styleOverrides: {
      containedPrimary: {
        background: brand.gradient,
        boxShadow: '0 4px 16px rgba(54,201,162,0.25)',
        '&:hover': { background: brand.gradientHover, boxShadow: '0 4px 20px rgba(54,201,162,0.35)' },
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: { backgroundImage: 'none' },
    },
  },
  MuiAccordion: {
    styleOverrides: {
      root: {
        background: `linear-gradient(135deg, ${brand.bgDark} 0%, #0d2a1e 100%)`,
        border: '1px solid rgba(255,255,255,0.06)',
        '&:before': { display: 'none' },
        '&.Mui-expanded': { margin: '8px 0' },
      },
    },
  },
  MuiCard: {
    styleOverrides: {
      root: {
        background: `linear-gradient(135deg, ${brand.bgDark} 0%, #0d2a1e 100%)`,
        border: '1px solid rgba(255,255,255,0.06)',
      },
    },
  },
  MuiBottomNavigation: {
    styleOverrides: {
      root: { backgroundColor: brand.bgDark },
    },
  },
  MuiBottomNavigationAction: {
    styleOverrides: {
      root: {
        '&.Mui-selected': { color: brand.primary },
      },
    },
  },
  MuiDivider: {
    styleOverrides: {
      root: { borderColor: 'rgba(255,255,255,0.08)' },
    },
  },
};

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: brand.primary, dark: brand.primaryDark, contrastText: '#ffffff' },
    background: { default: brand.bgDark, paper: brand.paperDark },
    text: { primary: '#ffffff', secondary: 'rgba(255,255,255,0.7)' },
  },
  typography,
  shape,
  components: sharedComponents,
});

export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: brand.primary, dark: brand.primaryDark, contrastText: '#ffffff' },
    background: { default: '#f5f7fa', paper: '#ffffff' },
  },
  typography,
  shape,
  components: sharedComponents,
});
